import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const BetaFeaturesSiteSettingsPageLoader: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BetaFeaturesSiteSettingsPage" */ '../src/BetaFeaturesSiteSettingsPage.tsx'
			)
		).BetaFeaturesSiteSettingsPage,
});
